import React from 'react'

import { Accordion, useAccordionItemIsOpen } from '@grammarly/badger-ui'

import { TypeSectionFaq } from '../../../lib/types/section-faq'
import { EntryContentProps } from '../../renderer'
import { renderRichTextMultiLineContent } from '../../renderer/rich-text'
import { PageSection } from '../../page-section'
import { FaqSchemaMarkup } from './faq-schema-markup'
import { Typography } from '@grammarly/badger-ui'
import { SectionThemeProvider, Themes } from '../../../contexts/section-theme-context'
import { TabSection } from '../tabs/tab-section'

const { C2 } = Typography

const AccordionButton = ({ children }: { children: React.ReactNode }) => {
  const isOpen = useAccordionItemIsOpen()
  return (
    <Accordion.Button>
      <C2 as="h3" bold={isOpen}>
        {children}
      </C2>
      <Accordion.Icon />
    </Accordion.Button>
  )
}

export const FaqSectionContent: React.FC<EntryContentProps<TypeSectionFaq>> = ({ structure }) => {
  const {
    fields: { content },
  } = structure

  return (
    <>
      <FaqSchemaMarkup content={content} />
      <Accordion>
        {content.map(({ fields: { question, answer } }) => (
          <Accordion.Item key={question}>
            <AccordionButton>{question}</AccordionButton>
            <Accordion.Panel>
              <SectionThemeProvider value={Themes.Light}>{renderRichTextMultiLineContent(answer)}</SectionThemeProvider>
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>
    </>
  )
}

export const FaqSection: React.FC<EntryContentProps<TypeSectionFaq>> = ({ structure }) => {
  const {
    sys,
    fields: { internalName, background, heading, alignment },
  } = structure

  return (
    <PageSection
      internalName={internalName}
      sysStructure={sys}
      background={background}
      alignment={alignment}
      heading={heading}
    >
      <FaqSectionContent structure={structure} />
    </PageSection>
  )
}

export const FaqSectionForTabs: React.FC<EntryContentProps<TypeSectionFaq>> = ({ structure }) => {
  const {
    fields: { background, heading, alignment },
  } = structure

  return (
    <TabSection background={background} alignment={alignment} heading={heading}>
      <FaqSectionContent structure={structure} />
    </TabSection>
  )
}
